<template>
   <NuxtLayout name="auth">
      <template #form>
         <SignupWizard />
      </template>
      <template #media>
         <AuthAnimation />
      </template>
   </NuxtLayout>
</template>

<script setup lang="ts">
import AuthAnimation from '~/components/auth/AuthAnimation.vue';
import { type AuthErrorCode, getAuthErrorCodes } from '~/constants/errorCodes';
import SignupWizard from '~/pages/signup/_components/SignupWizard.vue';
import { useToastStore } from '~/stores/toast';

const router = useRouter();

definePageMeta({
  layout: false,
});

const toastStore = useToastStore();

onMounted(() => {
  const err_code = router.currentRoute.value.query.err_code as unknown as AuthErrorCode;
  if (err_code) {
    toastStore.error(getAuthErrorCodes(err_code).message);
  }
});
</script>